export const mockRecommendedJobs = [
    { 
      id: 1, 
      title: 'Site Area Safety Supervisor', 
      company: 'LAFARGE Biskra', 
      location: 'Lyon, France', 
      experience: '4+ years', 
      contract: 'Contract (6 months)', 
      languages: ['English', 'French', 'Arabic'], 
      vacancies: 2, 
      posted: '3 days ago', 
      match: 92, 
      status: 'default' 
    },
    { 
      id: 2, 
      title: 'Civil Construction Coordinator', 
      company: 'Eiffage Genie Civil', 
      location: 'Toulouse, France', 
      experience: '5–7 years', 
      contract: 'Permanent', 
      languages: ['English', 'French'], 
      vacancies: 1, 
      posted: '20-Jul-2025', 
      match: 92, 
      status: 'default' 
    },
    { 
      id: 3, 
      title: 'Site Manager – Infrastructure Projects', 
      company: 'Bouygues Travaux Publics', 
      location: 'Marseille, France', 
      experience: '5+ years', 
      contract: 'Contract (12 months)', 
      languages: ['French'], 
      vacancies: 1, 
      salary: '4 Lacs PA', 
      posted: '10-Jul-2025', 
      match: 91, 
      status: 'default' 
    },
    { 
      id: 4, 
      title: 'EU Safety Compliance Site Supervisor', 
      company: 'Colas Europe', 
      location: 'Lille, France', 
      experience: '6 years', 
      contract: 'Permanent', 
      languages: ['English', 'French'], 
      vacancies: 1, 
      posted: '12-Jul-2025', 
      match: 91, 
      status: 'default' 
    },
    { 
      id: 5, 
      title: 'Project Site Lead – Cement Plant Upgrade', 
      company: 'LafargeHolcim', 
      location: 'Rouen, France', 
      experience: '6–8 years', 
      contract: 'Permanent', 
      languages: ['English', 'French'], 
      vacancies: 2, 
      posted: '3 days ago', 
      match: 90, 
      status: 'default' 
    },
    { 
      id: 6, 
      title: 'Construction Site Coordinator', 
      company: 'SPIE Batignolles', 
      location: 'Strasbourg, France', 
      experience: '5+ years', 
      contract: 'Permanent', 
      languages: ['English', 'French'], 
      salary: '6 Lacs PA', 
      vacancies: 2, 
      posted: '16-Jul-2025', 
      match: 89, 
      status: 'default' 
    },
    { 
      id: 7, 
      title: 'Field Supervisor – Commercial Buildings', 
      company: 'Nexity Construction', 
      location: 'Nice, France', 
      experience: 'N/A', 
      contract: 'Contract (6 months, extendable)', 
      languages: [], 
      salary: '', 
      vacancies: 0, 
      posted: '', 
      match: 89, 
      status: 'applied' 
    },
    { 
      id: 8, 
      title: 'Project Engineer – On-site Operations', 
      company: 'SOGEA SATOM', 
      location: 'Nantes, France', 
      experience: 'N/A', 
      contract: 'Permanent', 
      languages: [], 
      salary: '', 
      vacancies: 0, 
      posted: '', 
      match: 89, 
      status: 'applied' 
    },
  ];